import { useEffect, useState } from "react";

import { SelectChangeEvent } from "@mui/material";

import useAxios from "axios-hooks";

import FiltersDropDown from "components/dropdowns/filtersDropDown";
import { getLocalStorage } from "features/components/helperFunctions";
import { filtersStyles } from "features/orders/index.styles";
import {
  DropdownTypes,
  DropDownList,
  OrdersCityFilterRequest,
} from "utils/types";
import { useDispatch } from "store";
import { setSelectedCity } from "store/slices/Dropdown";

const CityFilter = ({ applyFilter }: DropdownTypes) => {
  const dispatch = useDispatch();
  const [citiesList, setCitiesList] = useState<DropDownList[]>([
    { label: "All Cities", value: "" },
  ]);
  const [cityFilterName, setCityFilterName] = useState<string[]>([
    citiesList[0].label,
  ]);
  const { eatout_id, user_id } = getLocalStorage();

  //======================================= API Call Payloads =======================================//

  // cities api call payload
  const citiesPayload = (cityData: OrdersCityFilterRequest) => {
    const formData = new FormData();

    formData.append("eatout_id", `${eatout_id}`);
    formData.append("admin_id", `${cityData["admin_id"]}`);
    formData.append("source", `${cityData["source"]}`);
    return formData;
  };

  const [{ loading, error }, getCitiesAPI] = useAxios(
    {
      url: "/order_city_filter",
      method: "post",
      data: citiesPayload({
        eatout_id: Number(eatout_id) || 0,
        source: "biz",
        admin_id: Number(user_id) || 0,
      }),
    },
    { manual: true }
  );

  //======================================= useEffect Hooks =======================================//

  useEffect(() => {
    (async () => {
      const citiesList = await getCitiesAPI();
      // load Cities dropdown
      if (citiesList && citiesList.data.result) {
        const cities = citiesList.data.result;
        const remaingCities = cities.map((status: string) => ({
          label: status,
          value: status,
        }));
        remaingCities.unshift({ label: "All Cities", value: "" });
        setCitiesList(remaingCities);
      }
    })();
  }, []);

  //======================================= Handler Functions =======================================//

  // city filter handler
  const handleCityFilterChange = (
    event: SelectChangeEvent<typeof cityFilterName>
  ) => {
    const {
      target: { value },
    } = event;

    let selectedCityResult: string[] = [];

    if (value && Array.isArray(value) && value.length) {
      // removing falsy values
      const filteredData = value.filter((element) => element);

      if (filteredData.length > 1) {
        /**
         * if => remove 'All cities' on selection of any other city
         * else if => remove other cities on selection of 'All cities'
         * else => other cities only
         */
        if (filteredData[0] === "All Cities") {
          selectedCityResult = filteredData?.filter(
            (cityName) => cityName !== "All Cities"
          );
        } else if (filteredData.some((city) => city === "All Cities")) {
          selectedCityResult = ["All Cities"];
        } else {
          selectedCityResult = filteredData?.filter(
            (cityName) => cityName !== "Select City"
          );
        }
      } else {
        selectedCityResult = filteredData;
      }
    } else {
      selectedCityResult = ["Select City"];
    }

    // setting value for filter component
    setCityFilterName(selectedCityResult);

    // setting city ids for API payload
    const cityIds = citiesList?.length
      ? citiesList.reduce((cityIds: string[], city) => {
          if (selectedCityResult?.some((cityName) => cityName === city.label)) {
            cityIds.push(city.value);
          }
          return cityIds;
        }, [])
      : [];

    // setting value in store for API
    dispatch(setSelectedCity(cityIds));
  };

  if (error) return <span>Getting Cities Failed</span>;

  return citiesList.length > 1 ? (
    <FiltersDropDown
      value={cityFilterName}
      onChange={handleCityFilterChange}
      dropDownList={citiesList}
      sx={filtersStyles}
      onChangeButton={applyFilter}
      disableButton={cityFilterName[0] === "Select City"}
    />
  ) : (
    <></>
  );
};

export default CityFilter;
